/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrderingProfileCatalogRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetOrderingProfileCatalogResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getOrderingProfileCatalog = (request: GetOrderingProfileCatalogRequest, options?: CashRequestOptions) => post<GetOrderingProfileCatalogRequest, GetOrderingProfileCatalogResponse>("/2.0/cash/get-ordering-profile-catalog", request, {...options, rejectOnError: true })